import { Controller } from "@hotwired/stimulus"
import debounce from "debounce";
import asyncFormSubmit from "./helpers/form_submit_helper";


export default class AutocompleteSortController extends Controller {
  static values = {
    turboForm: String
  }
  static targets = ["sortColumn", "sortDirection"]

  initialize() {
    this.submit = debounce(this.submit.bind(this), 150);
  }

  connect() {
    this.element.addEventListener("click->sort", this.sort);
  }

  sort(event) {
    const sortColumn = event.currentTarget.dataset.sortColumn;
    const initialDirection = event.currentTarget.dataset.sortInitialDirection;
    let sortDirection = 'asc';

    this.clearSortedHeaders();

    if (this.sortColumnTarget.value === sortColumn) {
      sortDirection = this.sortDirectionTarget.value === 'asc' ? 'desc' : 'asc';
    } else if (initialDirection) {
      sortDirection = initialDirection;
    } else if (sortColumn === 'title') {
      sortDirection = 'desc';
    }

    this.sortColumnTarget.value = sortColumn;
    this.sortDirectionTarget.value = sortDirection;

    this.updateHeaderClass(event.currentTarget, sortDirection);

    this.submit();
  }

  updateHeaderClass(sortedHeader, sortDirection) {
    sortedHeader.classList.add('sorted-header');
    if (sortDirection === 'desc') {
      sortedHeader.classList.add('desc');
    } else {
      sortedHeader.classList.remove('desc');
    }
  }

  clearSortedHeaders() {
    document.querySelectorAll('.sortable-header').forEach(header => {
      header.classList.remove('sorted-header', 'desc');
    });
  }

  submit() {
    if (this.turboFormValue === 'true') {
      asyncFormSubmit(this.element);
    }
    else {
      this.element.requestSubmit(); 
    }
  }
}
